/**
 * @generated SignedSource<<4f3e627bb1bf5e681d36b1064dd0f1d5>>
 * @relayHash b0522c191a144562921ea3633a92601a
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID b0522c191a144562921ea3633a92601a

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ccnId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "shortTitle"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sentForSignature",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "closed",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "confirmed",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sentToManagementSystem",
    "storageKey": null
  }
],
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MetricsProfileStatus",
    "kind": "LinkedField",
    "name": "manual",
    "plural": false,
    "selections": (v1/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "MetricsProfileStatus",
    "kind": "LinkedField",
    "name": "electronic",
    "plural": false,
    "selections": (v1/*: any*/),
    "storageKey": null
  }
],
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "ccnId",
        "variableName": "ccnId"
      },
      {
        "kind": "Variable",
        "name": "shortTitle",
        "variableName": "shortTitle"
      }
    ],
    "concreteType": "Metrics",
    "kind": "LinkedField",
    "name": "metrics",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ccnId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "shortTitle",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MetricsProfile",
        "kind": "LinkedField",
        "name": "groupe_adhesion",
        "plural": false,
        "selections": (v2/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CommercialNetworkMetricsProfile",
        "kind": "LinkedField",
        "name": "reseau_commercial",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricsProfile",
            "kind": "LinkedField",
            "name": "VAD",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricsProfile",
            "kind": "LinkedField",
            "name": "Mdpro",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricsProfile",
            "kind": "LinkedField",
            "name": "MDE",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MetricTableQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MetricTableQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "id": "b0522c191a144562921ea3633a92601a",
    "metadata": {},
    "name": "MetricTableQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

node.hash = "1ed0565ad10d688069f33866056b4248";

export default node;
